export default __webpack_public_path__ + "static/media/hangman.7b4e8862.PNG";